// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__ce2 {
  position: relative;
}

.anchorWrapper__a18 {
  display: contents;
}

.popup__bae.popup__bae {
  padding: calc(var(--ring-unit) * 4);
  max-width: calc(var(--ring-unit) * 67.5);
}

.content__c82 {
  font-size: var(--ring-font-size);
}

.messageIcon__dea.messageIcon__dea > div > [class^='icon'] {
  top: calc(var(--ring-unit) * 4.75);
  left: calc(var(--ring-unit) * 3.5);
}

.withIcon__ec4.withIcon__ec4 > h2,
.withIcon__ec4.withIcon__ec4 > div > *:not([data-test='stepped-message']) {
  margin-left: calc(var(--ring-unit) * 4);
}

.closeButton__f2d {
  position: absolute;
  top: calc(var(--ring-unit) * 2.5);
  right: calc(var(--ring-unit) * 2.5);
}

.title__f76.title__f76 {
  margin-top: 0;
  margin-bottom: calc(var(--ring-unit) * 2);
}
`, "",{"version":3,"sources":["webpack://./src/common/popup-message/popup-message.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,yCAAyC;AAC3C","sourcesContent":[".wrapper {\n  position: relative;\n}\n\n.anchorWrapper {\n  display: contents;\n}\n\n.popup.popup {\n  padding: calc(var(--ring-unit) * 4);\n  max-width: calc(var(--ring-unit) * 67.5);\n}\n\n.content {\n  font-size: var(--ring-font-size);\n}\n\n.messageIcon.messageIcon > div > [class^='icon'] {\n  top: calc(var(--ring-unit) * 4.75);\n  left: calc(var(--ring-unit) * 3.5);\n}\n\n.withIcon.withIcon > h2,\n.withIcon.withIcon > div > *:not([data-test='stepped-message']) {\n  margin-left: calc(var(--ring-unit) * 4);\n}\n\n.closeButton {\n  position: absolute;\n  top: calc(var(--ring-unit) * 2.5);\n  right: calc(var(--ring-unit) * 2.5);\n}\n\n.title.title {\n  margin-top: 0;\n  margin-bottom: calc(var(--ring-unit) * 2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__ce2`,
	"anchorWrapper": `anchorWrapper__a18`,
	"popup": `popup__bae`,
	"content": `content__c82`,
	"messageIcon": `messageIcon__dea`,
	"withIcon": `withIcon__ec4`,
	"closeButton": `closeButton__f2d`,
	"title": `title__f76`
};
export default ___CSS_LOADER_EXPORT___;
